var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoadGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.995.35a1 1 0 00-.982-.013l-4.03 2.2a1 1 0 00.01 1.761l4.031 2.14a1 1 0 00.961-.013l3.783-2.14a1 1 0 00.01-1.734L6.995.35zM0 10.112a1 1 0 00.522.878l4.173 2.272a1 1 0 001.478-.878V7.849a1 1 0 00-.532-.883l-4.173-2.21A1 1 0 000 5.642v4.47zM12.783 5.539a1 1 0 00-1.495-.827l-3.94 2.245a1 1 0 00-.504.869v4.555a1 1 0 001.479.878l4.13-2.255a1 1 0 00.52-.92l-.19-4.545z",
    fill: "#818181"
  })));
}

export default SvgLoadGrey;